module.exports = __webpack_public_path__ + "static/media/slide-3.974b6577.png";